import React from 'react';
import { X, GitCompare } from 'lucide-react';
import { diffWords, stripHtml } from '../../../lib/diff';

const bodyOf = (rev) => stripHtml((rev?.content && rev.content.body_html) || '');

const DiffView = ({ a, b, onClose }) => {
  if (!a || !b) return null;
  const [oldRev, newRev] = a.version <= b.version ? [a, b] : [b, a];
  const tokens = diffWords(bodyOf(oldRev), bodyOf(newRev));

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-slate-800 border border-slate-700 rounded-xl w-full max-w-3xl mx-4 shadow-2xl max-h-[85vh] flex flex-col" data-testid="cms-diff-modal">
        <div className="flex items-center justify-between p-5 border-b border-slate-700">
          <h2 className="text-lg font-semibold text-white flex items-center gap-2">
            <GitCompare className="w-5 h-5 text-amber-400" />
            Compare v{oldRev.version} → v{newRev.version}
          </h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg" data-testid="cms-diff-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex items-center gap-4 px-5 py-2 text-xs text-slate-400 border-b border-slate-700/50">
          <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-500/40 border border-red-500/50" /> Removed</span>
          <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-emerald-500/40 border border-emerald-500/50" /> Added</span>
          <span className="ml-auto">Read-only</span>
        </div>
        <div className="p-5 overflow-y-auto text-sm text-slate-200 leading-relaxed whitespace-pre-wrap" data-testid="cms-diff-content">
          {tokens.length === 0 ? (
            <span className="text-slate-500">No textual content to compare.</span>
          ) : tokens.map((t, i) => {
            if (t.type === 'added') return <span key={i} className="bg-emerald-500/25 text-emerald-200 rounded-sm">{t.value}</span>;
            if (t.type === 'removed') return <span key={i} className="bg-red-500/25 text-red-300 line-through rounded-sm">{t.value}</span>;
            return <span key={i}>{t.value}</span>;
          })}
        </div>
      </div>
    </div>
  );
};

export default DiffView;
